import { flashMessage, flashErrorMessage } from 'redux-flash'

import axios from './axios'
import { i18n } from './i18n'

import { makeReduxAuth } from '@bit/amazingdesign.react-redux-mui-starter.make-redux-auth'
import { makeAuthRequests } from '@bit/amazingdesign.react-redux-mui-starter.make-auth-requests'

const LOG_IN_URL = window._env_.REACT_APP_LOG_IN_URL
const REFRESH_TOKEN_URL = window._env_.REACT_APP_REFRESH_TOKEN_URL
const FORGOT_PASSWORD_URL = window._env_.REACT_APP_FORGOT_PASSWORD_URL
const RESET_PASSWORD_URL = window._env_.REACT_APP_RESET_PASSWORD_URL
// REACT_APP_API_URL kończy się na /api (jak w restServices.js)
const CHANGE_PASSWORD_URL = `${window._env_.REACT_APP_API_URL}/account/changePassword`

const t = i18n.t.bind(i18n)

const flashSuccessMessage = (message, options) => flashMessage(message, { ...options, props: { variant: 'success' } })

// Tokeny w localStorage pod tymi samymi kluczami co w vendorowanym pakiecie
// @bit/amazingdesign.react-redux-mui-starter.make-auth-requests 0.0.3 (makeAuthRequests.js, funkcja saveTokens;
// czytają je getAccessToken i refreshTokens). Pakiet nie wystawia tej funkcji, a po zmianie hasła stary
// refreshToken traci ważność, więc nową parę z odpowiedzi API zapisujemy sami.
export const saveTokens = (accessToken, refreshToken) => {
  localStorage.setItem('accessToken', accessToken)
  localStorage.setItem('refreshToken', refreshToken)
}

const isNonEmptyString = (value) => typeof value === 'string' && value.length > 0

// Zmiana własnego hasła zalogowanego użytkownika (nagłówek Authorization dodaje interceptor z axios.js).
// Odpowiedź 200 niesie nową parę tokenów; bez obu tokenów nie zapisujemy nic (zamiast napisu „undefined”).
export const changePassword = (currentPassword, newPassword) => (
  axios.post(CHANGE_PASSWORD_URL, { currentPassword, newPassword })
    .then((response) => {
      const { accessToken, refreshToken } = (response && response.data) || {}

      if (!isNonEmptyString(accessToken) || !isNonEmptyString(refreshToken)) {
        throw new Error('Odpowiedź zmiany hasła bez tokenów')
      }

      saveTokens(accessToken, refreshToken)
    })
)

export const {
  logIn,
  logOut,
  refreshTokens,
  getAccessToken,
  checkIfLoggedIn,
  sendForgotPasswordEmail,
  resetPassword,
} = makeAuthRequests({
  loginRequestFunction: (email, password) => (
    axios.post(LOG_IN_URL, { email, password })
  ),
  refreshTokenRequestFunction: (refreshToken) => (
    axios.post(REFRESH_TOKEN_URL, { refreshToken })
  ),
  forgotPasswordRequestFunction: (email) => axios.post(FORGOT_PASSWORD_URL, { email }),
  resetPasswordRequestFunction: (password, data) => (
    axios.post(RESET_PASSWORD_URL, { password, passwordResetToken: data.passwordResetToken })
  ),
})

export const {
  logInAsyncAction,
  logOutAsyncAction,
  checkIfLoggedInAsyncAction,
  sendForgotPasswordEmailAsyncAction,
  setUserDataAction,
  userIsLoggingInAction,
  userLoginFailureAction,
  setUserIsLoggedInAction,
  setUserIsLoggedOutAction,
  resetPasswordAsyncAction,
  reducer,
} = makeReduxAuth(
  { logIn, logOut, checkIfLoggedIn, sendForgotPasswordEmail, resetPassword },
  { flashMessage, flashErrorMessage, flashSuccessMessage },
  t
)